// extracted by mini-css-extract-plugin
export default {"fileViewer":"PreviewDocuement_fileViewer__6PgVd","detailViewerPreview":"PreviewDocuement_detailViewerPreview__9EIhW","k-link":"PreviewDocuement_k-link__ve1iH"};